module.exports = __webpack_public_path__ + "img/4.8598cc22.png";